import ImageSelect from "@/design/components/ImageSelect";
import FormGroup from "@/design/forms/FormGroup";
import InputSelect from "@/design/forms/InputSelect";

import { FormHelperText, Grid } from "@mui/material";
import PropTypes from "prop-types";

function Personalization({ formHandler, user, specs }) {
  return (
    <FormGroup title="Personalization">
      {(specs?.wallpaper === "yes" || !specs) && (
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <ImageSelect
            label="Wallpaper"
            id="wallpaper"
            value={user.wallpaper ? user.wallpaper.id : null}
            select={(value) => formHandler("wallpaper", value)}
            defaultLabel="PBX default"
          />
          <FormHelperText>Set a wallpaper for any device this user is applied to.</FormHelperText>
        </Grid>
      )}
      {(specs?.screensaver === "yes" || !specs) && (
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <ImageSelect
            label="Screensaver"
            id="screensaver"
            value={user.screensaver ? user.screensaver.id : null}
            select={(value) => formHandler("screensaver", value)}
            defaultLabel="PBX default"
          />
          <FormHelperText>Set a screensaver for any device this user is applied to.</FormHelperText>
        </Grid>
      )}
      <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
        <InputSelect
          id="deviceLanguage"
          label="Device language"
          onChange={formHandler}
          value={user.deviceLanguage}
          selectValue="value"
          selects={[
            { value: "dutch", label: "Dutch" },
            { value: "english", label: "English" },
            { value: "french", label: "French" },
            { value: "german", label: "German" },
            { value: "italian", label: "Italian" },
            { value: "polish", label: "Polish" },
            { value: "portuguese", label: "Portuguese" },
            { value: "russian", label: "Russian" },
            { value: "spanish", label: "Spanish" },
            { value: "turkish", label: "Turkish" },
          ]}
          getOptionLabel={(option) => option.label}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
        <InputSelect
          id="labelFormat"
          label="Label format"
          onChange={formHandler}
          value={user.labelFormat}
          selectValue="value"
          selects={[
            { value: "name", label: "Name" },
            { value: "number", label: "Number" },
            { value: "both", label: "Both" },
          ]}
          getOptionLabel={(option) => option.label}
        />
      </Grid>
      {(specs?.dsskeyLength === "yes" || !specs) && (
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <InputSelect
            id="dssKeyLength"
            label="Line key length"
            onChange={formHandler}
            value={user.dssKeyLength}
            selectValue="value"
            selects={[
              { value: "default", label: "Default" },
              { value: "medium", label: "Medium" },
              { value: "large", label: "Large" },
            ]}
            getOptionLabel={(option) => option.label}
          />
        </Grid>
      )}
    </FormGroup>
  );
}

Personalization.propTypes = {
  user: PropTypes.object,
  formHandler: PropTypes.func,
  specs: PropTypes.object,
};

export default Personalization;
